import { render, staticRenderFns } from "./DirectoryArchived.vue?vue&type=template&id=77c915fa&scoped=true&"
import script from "./DirectoryArchived.vue?vue&type=script&lang=js&"
export * from "./DirectoryArchived.vue?vue&type=script&lang=js&"
import style0 from "styles/viewAll.scss?vue&type=style&index=0&id=77c915fa&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=77c915fa&lang=scss&scoped=true&"
import style2 from "styles/dashboard/datatable.scss?vue&type=style&index=2&id=77c915fa&lang=scss&scoped=true&"
import style3 from "./DirectoryArchived.vue?vue&type=style&index=3&id=77c915fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c915fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c915fa')) {
      api.createRecord('77c915fa', component.options)
    } else {
      api.reload('77c915fa', component.options)
    }
    module.hot.accept("./DirectoryArchived.vue?vue&type=template&id=77c915fa&scoped=true&", function () {
      api.rerender('77c915fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryArchived.vue"
export default component.exports